module.exports = __webpack_public_path__ + "img/posz.fe12b4ee.jpg";